import React from "react";
import { CalendarCheck, LayoutDashboard, MapPin, MessageSquare, Search } from "lucide-react";

const STEPS = [
  {
    icon: Search,
    color: "#017bef",
    title: "Discover",
    description: "Search and compare spaces and experiences near you or wherever you are headed.",
  },
  {
    icon: CalendarCheck,
    color: "#0062c0",
    title: "Book",
    description: "Check real-time availability and book instantly. No waiting, no back-and-forth.",
  },
  {
    icon: LayoutDashboard,
    color: "#017bef",
    title: "Manage",
    description: "Keep all your Work, Stay and Play reservations in one place, in one account.",
  },
  {
    icon: MapPin,
    color: "#0062c0",
    title: "Experience",
    description: "Arrive, check in and enjoy your space or experience exactly as booked.",
  },
  {
    icon: MessageSquare,
    color: "#017bef",
    title: "Review",
    description: "Share your experience and help others discover great spaces across Africa.",
  },
];

export default function HowItWorksSection() {
  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <p className="text-center text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">
          How It Works
        </p>
        <h2 className="pt-[12px] text-center text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
          From Discovery to Experience
        </h2>

        <div className="relative pt-14">
          {/* Connector through the centre of the step circles (desktop only) */}
          <div
            className="absolute left-[10%] right-[10%] top-[94px] hidden h-px lg:block"
            style={{ backgroundImage: "linear-gradient(90deg, #017bef 0%, #0062c0 100%)" }}
          />
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-[16px]">
            {STEPS.map(({ icon: Icon, color, title, description }, index) => (
              <div key={title} className="relative flex flex-col items-center text-center">
                <div
                  className="mb-[20px] flex size-[76px] items-center justify-center rounded-full border-4 border-solid border-white"
                  style={{ backgroundColor: color }}
                >
                  <Icon className="size-[22px] text-white" />
                </div>
                <span className="pb-2 text-[12px] font-bold leading-4 tracking-[1.2px] text-[#717182]">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h3 className="pb-2 text-[18px] font-bold leading-[27px] text-[#0a0a0a]">{title}</h3>
                <p className="max-w-[263px] text-[12px] leading-[19.5px] text-[#717182]">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
